<template>
  <TabsWrapper>
    <Tab title="Prozessreihenfolge" group="Erste Schritte">
      <h2 class="font-bold">Prozessreihenfolge</h2>
      <ol class="list-decimal list-inside space-y-2 text-sm">
        <li>Installation von DMGW im Gebäude</li>
        <li>Kopplung mit Q-Tool</li>
        <li>Geräte in Nutzeinheiten installieren</li>
        <li>Funkstatus der Geräte in jeder Nutzeinheit überprüfen</li>
      </ol>
    </Tab>

    <Tab title="GW Installation im Gebäude" group="Erste Schritte">
      <div class="flex flex-col gap-3 text-sm">
        <h2 class="font-bold">
          Umgebungsbedingungen für eine optimale Funkleistung
        </h2>
        <p>
          Installationslimit: Ein Gateway sollte maximal 3 Etagen und 12
          Nutzungseinheiten abdecken
          <br />
          <br />Bei Überschreitung ist ein zusätzliches Gateway erforderlich
        </p>
        <img
          alt="dmg6Installation"
          src="@/assets/img/dmg6/dmg6Installation.svg"
          class="dark:invert max-w-2xl"
        />
      </div>
    </Tab>

    <Tab title="Standort finden (LTE-Check)" group="Erste Schritte">
      <div class="flex flex-col gap-3 text-sm">
        <h2 class="font-bold">Standort finden (LTE-Check)</h2>
        <p>
          DMGW Erfassungsmaske öffnen
          <br />
          <br />
          Der LTE-Scan startet automatisch
          <br />
          <br />
          Position suchen: Mit dem Tablet im Raum bewegen, bis die Anzeige GRÜN
          leuchtet
        </p>
        <div
          class="flex items-center gap-2 rounded-lg bg-light-3 dark:bg-dark-3 px-4 py-2.5 w-fit"
        >
          <span class="w-3 h-3 rounded-full bg-green-500 shrink-0" />
          <span>LTE: Optimal</span>
        </div>
        <p>Jetzt kann das Gerät erfasst und installiert werden</p>
      </div>
    </Tab>

    <Tab title="DMGW Inbetriebnahme" group="Erste Schritte">
      <div class="flex flex-col gap-3 text-sm">
        <h2 class="font-bold">DMGW Inbetriebnahme</h2>
        <p>
          Montage: Gerät an der Wand montieren.<br /><br />
          Bei Außenmontage (z. B. im Laubengang): zwingend eine Schutzbox mit
          IP65 verwenden.
          <br /><br />
          Gerät einschalten/aufwecken: Deckel des GW öffnen und den Stecker vom
          Batteriefach mit dem DMGW-Panel verbinden.
          <br /><br />
          Den Knopf am Panel so lange gedrückt halten, bis es ORANGE zu blinken
          beginnt.
          <br /><br />
          Wenn das LED-Signal auf GRÜN blinkend wechselt, wieder schließen und
          verplomben.
          <br /><br />
        </p>
      </div>
    </Tab>

    <Tab title="DMGW mit Q-Tool koppeln" group="Erste Schritte">
      <div class="flex flex-col gap-3 text-sm">
        <h2 class="font-bold">Gateway mit Q-Tool koppeln</h2>
        <p>
          Q-Tool verbinden: In bxTool auf "Verbinden" tippen. Kopplungsvorgang
          startet automatisch
          <br /><br />
          Nach dem Beenden der Kopplung speichern. Jetzt kannst Du mit der
          Installation der Messgeräte beginnen
        </p>
      </div>
    </Tab>

    <Tab title="Geräte Funkcheck" group="Geräte Installieren">
      <div class="flex flex-col gap-3 text-sm">
        <h2 class="font-bold">
          Geräte Installation mit dem anschließenden Funkcheck
        </h2>
        <p>
          HKV, RWM, wie gewohnt installieren, anschließend Funkcheck
          durchführen.
          <br /><br />
          Wasser-/Wärmezähler: Falls nötig, manuell per Infrarot (Q-Tool)
          "aufwecken".
        </p>
        <h3 class="font-bold">Funk-Status prüfen (Ampel)</h3>
        <table class="w-full border border-light-4 dark:border-dark-2">
          <tbody>
            <tr class="border-t border-light-4 dark:border-dark-2">
              <td class="px-4 py-3 whitespace-nowrap w-24">
                <div class="flex items-center gap-2">
                  <em class="mdi mdi-check-circle text-lg text-green-500" />
                  <span>Grün</span>
                </div>
              </td>
              <td class="px-4 py-3">
                Signal ist erfolgreich am Gateway angekommen
              </td>
              <td class="px-4 py-3">Keine Maßnahme erforderlich</td>
            </tr>
            <tr class="border-t border-light-4 dark:border-dark-2">
              <td class="px-4 py-3 whitespace-nowrap w-24">
                <div class="flex items-center gap-2">
                  <em class="mdi mdi-check-circle text-lg text-yellow-400" />
                  <span>Gelb</span>
                </div>
              </td>
              <td class="px-4 py-3">
                Gerät sendet (vom Q-Tool empfangen) Keine Antwort vom DMGW
              </td>
              <td class="px-4 py-3">
                Reichweite nicht ausreichend oder blockiert, lokale Umgebung
                prüfen, bei mehrfach GELB weiteres DMGW oder Repeter
                installieren
              </td>
            </tr>
            <tr class="border-t border-light-4 dark:border-dark-2">
              <td class="px-4 py-3 whitespace-nowrap w-24">
                <div class="flex items-center gap-2">
                  <em class="mdi mdi-circle-outline text-lg text-gray-400" />
                  <span>Grau</span>
                </div>
              </td>
              <td class="px-4 py-3">Noch kein Status ausgelesen</td>
              <td class="px-4 py-3">2-4 min warten</td>
            </tr>
          </tbody>
        </table>
      </div>
    </Tab>

    <Tab title="Verbindungen prüfen" group="Problembehebung">
      <div class="flex flex-col gap-3 text-sm">
        <h3 class="font-bold">DMGW Schlafmodus</h3>
        <p>
          Um DMGW aus dem Schlafmodus zu wecken. Deckel des Gerätes öffnen, den
          Knopf solange drücken bis es erst ORANGE und anschließend GRÜN blinkt
        </p>
        <h3 class="font-bold mt-2">Q-Tool nicht mehr gekoppelt</h3>
        <p>
          Die erneute Kopplung des Q-Tools kannst Du wiederherstellen, indem Du
          auf Gerät-Symbol im linken Seitenmenü unten tippst.
        </p>
        <div class="flex items-center gap-3 mt-1">
          <em class="mdi mdi-remote text-2xl" />
          <em class="mdi mdi-arrow-right" />
          <div
            class="flex items-center rounded-full border-2 border-primary-2 p-0.5 text-xs"
          >
            <span class="rounded-full px-3 py-1">Verbindungen</span>
            <span
              class="flex items-center gap-1 rounded-full bg-light-3 dark:bg-dark-3 px-3 py-1 font-semibold"
            >
              <em class="mdi mdi-help-circle-outline" />
              DMGW Hilfe
            </span>
          </div>
        </div>
      </div>
    </Tab>

    <Tab title="Blinksignale am DMGW" group="Problembehebung">
      <div class="flex flex-col gap-3 text-sm">
        <h2 class="font-bold">Blinksignale am DMGW</h2>
        <table class="w-full border border-light-4 dark:border-dark-2">
          <thead>
            <tr class="border-b border-light-4 dark:border-dark-2">
              <th class="px-4 py-2.5 text-left font-medium">Farbe</th>
              <th class="px-4 py-2.5 text-left font-medium">Status</th>
              <th class="px-4 py-2.5 text-left font-medium">Bedeutung</th>
            </tr>
          </thead>
          <tbody>
            <tr class="border-t border-light-4 dark:border-dark-2">
              <td class="px-4 py-3">
                <div class="flex items-center gap-2">
                  <span class="w-3 h-3 rounded-full bg-orange-400 shrink-0" />
                  Orange
                </div>
              </td>
              <td class="px-4 py-3">Blinkt</td>
              <td class="px-4 py-3">Verbindungsaufbau</td>
            </tr>
            <tr class="border-t border-light-4 dark:border-dark-2">
              <td class="px-4 py-3">
                <div class="flex items-center gap-2">
                  <span class="w-3 h-3 rounded-full bg-orange-400 shrink-0" />
                  Orange
                </div>
              </td>
              <td class="px-4 py-3">Leuchtet</td>
              <td class="px-4 py-3">Verbunden</td>
            </tr>
            <tr class="border-t border-light-4 dark:border-dark-2">
              <td class="px-4 py-3">
                <div class="flex items-center gap-2">
                  <span class="w-3 h-3 rounded-full bg-green-500 shrink-0" />
                  Grün
                </div>
              </td>
              <td class="px-4 py-3">Blinkt</td>
              <td class="px-4 py-3">Zählersuche läuft</td>
            </tr>
            <tr class="border-t border-light-4 dark:border-dark-2">
              <td class="px-4 py-3">
                <div class="flex items-center gap-2">
                  <span class="w-3 h-3 rounded-full bg-green-500 shrink-0" />
                  Grün
                </div>
              </td>
              <td class="px-4 py-3">Leuchtet</td>
              <td class="px-4 py-3">Erfolg! Vorgang abgeschlossen</td>
            </tr>
            <tr class="border-t border-light-4 dark:border-dark-2">
              <td class="px-4 py-3">
                <div class="flex items-center gap-2">
                  <span class="w-3 h-3 rounded-full bg-red-500 shrink-0" />
                  Rot
                </div>
              </td>
              <td class="px-4 py-3">Leuchtet</td>
              <td class="px-4 py-3">Fehler. Keine Verbindung</td>
            </tr>
            <tr class="border-t border-light-4 dark:border-dark-2">
              <td class="px-4 py-3">
                <div class="flex items-center gap-2">
                  <span class="w-3 h-3 rounded-full bg-red-500 shrink-0" />
                  Rot
                </div>
              </td>
              <td class="px-4 py-3">Leuchtet kurz</td>
              <td class="px-4 py-3">Manueller Abbruch bestätigt</td>
            </tr>
          </tbody>
        </table>
      </div>
    </Tab>
  </TabsWrapper>
</template>

<script setup lang="ts">
import TabsWrapper from '@/components/UI/Tabs/TabsWrapper.vue';
import Tab from '@/components/UI/Tabs/Tab.vue';
import dmg6InstallationSvg from '@/assets/img/dmg6/dmg6Installation.svg?raw';
</script>
